import { createStore } from "vuex";

export const store = createStore({
  state: {
    playerlist: [
      {
        id: 1,
        name: "Auston Matthews",
        position: "Center",
        team: "Toronto Maple Leafs",
        points: 20
      },
      {
        id: 9,
        name: "Jack Eichel",
        position: "Wing",
        team: "Buffalo Sabres",
        points: 2
      },
      {
        id: 2,
        name: "Carey Price",
        position: "Goalie",
        team: "Montreal Canadiens"
      },
      {
        id: 3,
        name: "William Nylander",
        position: "Wing",
        team: "Toronto Maple Leafs",
        points: 8
      },
      {
        id: 8,
        name: "Connor McDavid",
        position: "Center",
        team: "Edmonton Oilers",
        points: 16
      },
      {
        id: 6,
        name: "Erik Karlsson",
        position: "Defenceman",
        team: "San Jose Sharks",
        points: 9
      },
      {
        id: 4,
        name: "John Tavares",
        position: "Center",
        team: "Toronto Maple Leafs",
        points: 4
      },
      {
        id: 5,
        name: "Mitch Marner",
        position: "Wing",
        team: "Toronto Maple Leafs",
        points: 12
      },
      {
        id: 10,
        name: "Brendan Gallagher",
        position: "Wing",
        team: "Montreal Canadiens",
        points: 8
      }
    ]
  },
  getters: {
    playerlist: (state) => {
      return state.playerlist;
    },
    player: (state) => (id) => {
      return state.playerlist.find((player) => player.id === id);
    }
  }
});
